import { Table, Tag } from "antd";
import { getMerchantOrders } from "../actions/merchant_actions";
import { useQuery } from "@tanstack/react-query";
import ContentLayout from "../components/layout/ContentLayout";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const MerchantOrders = () => {
  const { t } = useTranslation();
  const businessSlug = useSelector((state) => state.account.businessSlug);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const { data, isLoading } = useQuery({
    queryKey: ["merchant-orders", page, pageSize],
    queryFn: () =>
      getMerchantOrders({
        page,
        pageSize,
        business_slug: businessSlug,
      }),
    keepPreviousData: true,
  });

  const orders = data?.data?.body?.docs || [];
  const total = data?.data?.body?.totalDocs || 0;

  const columns = [
    {
      title: t("order_id"),
      dataIndex: "id",
      key: "id",
      render: (id) => <span className="order-id">{id.slice(0, 8)}...</span>,
    },
    {
      title: t("customer"),
      dataIndex: "customerEmail",
      key: "customerEmail",
      render: (email) => email || <Tag color="volcano">{t("unknown")}</Tag>,
    },
    {
      title: t("status"),
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "PENDING" ? "orange" : "green"}>{status}</Tag>
      ),
    },
    {
      title: t("payment"),
      dataIndex: "paymentStatus",
      key: "paymentStatus",
      render: (payStatus) => (
        <Tag color={payStatus === "PENDING" ? "red" : "green"}>{payStatus}</Tag>
      ),
    },
    {
      title: t("total"),
      dataIndex: "totalAmount",
      key: "totalAmount",
      render: (amt) => `${t("sar_currency")} ${amt}`,
    },
    {
      title: t("created_at"),
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => new Date(date).toLocaleString(),
    },
  ];

  const expandedRowRender = (order) => {
    const itemColumns = [
      {
        title: t("product"),
        dataIndex: ["product", "name_en"],
        key: "productName",
        render: (name) => (
          <div className="product-cell">
            <img
              src={`https://dummyimage.com/40x40/ddd/000&text=${name?.charAt(
                0
              )}`}
              alt={name}
              className="product-img"
            />
            <span>{name}</span>
          </div>
        ),
      },
      {
        title: t("sku"),
        dataIndex: ["product", "sku"],
        key: "sku",
      },
      {
        title: t("quantity"),
        dataIndex: "quantity",
        key: "quantity",
      },
      {
        title: t("unit_price"),
        dataIndex: "unitPrice",
        key: "unitPrice",
        render: (price) => `${t("sar_currency")} ${price}`,
      },
    ];
    return (
      <Table
        columns={itemColumns}
        dataSource={order.orderItems}
        rowKey="id"
        pagination={false}
        className="nested-table"
        size="small"
        scroll={{ x: true }}
      />
    );
  };

  return (
    <ContentLayout
      header={
        <>
          <h1>
            {t("merchant_orders")} <span>{}</span>
          </h1>
          <h4>{t("view_merchant_orders")}</h4>
        </>
      }
    >
      <div className="merchant-orders">
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns}
          dataSource={orders}
          expandable={{ expandedRowRender }}
          scroll={{ x: true }}
          pagination={{
            current: page,
            pageSize,
            total,
            showSizeChanger: true,
            onChange: (newPage, newPageSize) => {
              setPage(newPage);
              setPageSize(newPageSize);
            },
          }}
        />
      </div>
    </ContentLayout>
  );
};

export default MerchantOrders;
